import { render, staticRenderFns } from "./my-presentation-box.vue?vue&type=template&id=efa9d978&scoped=true&"
import script from "./my-presentation-box.vue?vue&type=script&lang=js&"
export * from "./my-presentation-box.vue?vue&type=script&lang=js&"
import style0 from "./my-presentation-box.vue?vue&type=style&index=0&id=efa9d978&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa9d978",
  null
  
)

export default component.exports